import { useEffect, useState } from 'react';
import { loadMModesCached } from '../api/mmode';

// 加工模式值 → 显示名的公共取数层.
// ★设计A: mm_mode 字典是加工模式词表的唯一事实来源 (维护页 /admin/mmode), 展示侧一律从它取名,
// 不在页面里另抄一份 code→中文 的常量表 —— 抄出来的表必然与字典漂移:
// 数据资产两个中心各抄过一份, 同一个 LASER_CYLINDER 一处叫"圆柱加工"一处叫"旋转体加工",
// 字典里有名字的 LASER_EXTENDER/RELIEF_PROCESS/PASS_THROUGH… 则全裸显 code.
// 取数走 api/mmode 的模块级缓存 (loadMModesCached), 全站一次请求.

export function useMModeText(): (value?: string, fallback?: string) => string {
    const [names, setNames] = useState<Map<string, string>>(new Map());
    useEffect(() => {
        loadMModesCached().then((ms) => {
            const m = new Map<string, string>();
            ms.forEach((x) => {
                const n = x.nameZh || x.nameEn;
                if (n) m.set(x.value, n);
            });
            setNames(m);
        });
    }, []);
    // 字典未收录的模式回退原 code (不吞数据); 空值给 fallback.
    return (value, fallback = '—') => (value ? names.get(value) || value : fallback);
}
